export const EXCMCASEPROBLEM_CREATE_RESET = 'EXCMCASEPROBLEM_CREATE_RESET'
export const EXCMCASEPROBLEM_CREATE_SET_CREATED = 'EXCMCASEPROBLEM_CREATE_SET_CREATED'
export const EXCMCASEPROBLEM_CREATE_SET_ERROR = 'EXCMCASEPROBLEM_CREATE_SET_ERROR'
export const EXCMCASEPROBLEM_CREATE_SET_VIOLATIONS = 'EXCMCASEPROBLEM_CREATE_SET_VIOLATIONS'
export const EXCMCASEPROBLEM_CREATE_TOGGLE_LOADING = 'EXCMCASEPROBLEM_CREATE_TOGGLE_LOADING'
